'use client';

// import { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "../styles/home.module.css";

export default function NavigationBar() {

  const router = useLocation();

  const NavBarClass = () => {
    switch (router.pathname) {
      case "/":
        return styles.NavigationBar;
      default:
        return styles.NavigationBarWhite;
    }
  }


  return (
    <div className={styles.Container}>
      <nav className={ `${styles.NavigationBar} ${NavBarClass()}`}>
          <img src="/orbis-logo.jpg"  height= "60px" width="60px" alt="logo" className={styles.logo}/>
          <ul className={styles.navLinks}>
            <li className={styles.navItem}>
              <a href="/">Home</a>
            </li>
            <li className={styles.navItem}>
              <a href="/Get-Pre-Approved">Get Pre-Approved</a>
            </li>
            <li className={styles.navItem}>
              <a href="/Search-Listings">Search Listings</a>
            </li>
            <li className={styles.navItem}>
              <a href="/Resident-Portal">Resident Portal</a>
            </li>
            <li className={styles.navItem}>
              <a href="/About-us">About Us</a>
            </li>
          </ul>
      </nav>
      
    </div>
  );
}
